import React, {useEffect, useState} from 'react';

import {
    Alert,
    Button, Card, CardBody, CardReadMore, CardText, CardTitle,
    Col, Container, Dropdown,
    DropdownMenu,
    DropdownToggle, FormGroup,
    Icon,
    Input, Label,
    LinkList,
    LinkListItem, RegisterOptions,
    Row,
    Select,
    Toggle
} from "design-react-kit";
import {properties} from "../../../config/properties";
import {useNavigate} from "react-router-dom";
import CustomTooltip from "../../utils/customToolTip";
const styles = {
    card: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle: {
        padding: '2rem',
        borderRadius: 'none',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px #fefefe',
        transition: 'transform 0.2s ease-in-out',
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '1rem' // Spazio tra i pulsanti
    },
    sectionTitle: {
        fontSize: '1.1rem',
        fontWeight: '700',
        color: '#0b5ed7',
        borderBottom: '2px solid #0b5ed7',
        paddingBottom: '0.25rem',
        marginBottom: '1rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    titleIcon: {
        marginRight: '0.75rem',
    },
    formTitle: {
        marginBottom: '1.5rem',
        color: '#333',

        paddingBottom: '0.5rem'
    },
};
const InserimentoPersona = ({user}) => {


    const [isOpen, setIsOpen] = useState(false);
    const [titoli, setTitoli] = useState([]);
    const [ruoli, setRuoli] = useState([]);
    const [aree, setAree] = useState([]);
    const [titolo, setTitolo] = useState('null');
    const [ruolo, setRuolo] = useState('');
    const [area, setArea] = useState('');
    const [nome, setNome] = useState('');
    const [cognome, setCognome] = useState('');
    const [codiceFiscale, setCodiceFiscale] = useState('');
    const [resetCount, setResetCount] = useState(0);

    const [tooltipField, setTooltipField] = useState(null);
    const [tooltipMessage, setTooltipMessage] = useState('');

    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });

    const navigate = useNavigate();

    async function getRuoliList() {
        try {

            setAlert({ visible: false, type: '', message: '' });

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/ruoli`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");
            const json = await res.json();
            return json;  // qui ritorni direttamente l'array ricevuto
        } catch (e) {
            return [];
        }
    }


    async function getAreeList() {
        try {

            setAlert({ visible: false, type: '', message: '' });

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/areeCompetenza`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");
            const json = await res.json();
            return json;  // qui ritorni direttamente l'array ricevuto
        } catch (e) {
            return [];
        }
    }

    async function getTitoliList() {
        try {

            setAlert({ visible: false, type: '', message: '' });

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/titoli`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");
            const json = await res.json();
            return json;  // qui ritorni direttamente l'array ricevuto
        } catch (e) {
            return [];
        }
    }


    useEffect(() => {
        async function fetchData() {
            const dataRuoli = await getRuoliList();
            const dataAree = await getAreeList();
            const dataTitoli = await getTitoliList();
            setTitoli(dataTitoli?.titoli ?? []);
            setRuoli(dataRuoli?.ruoli ?? []);
            setAree(dataAree?.areeCompetenza ?? [])
        }
        fetchData();
    }, []);


    const handleConferma = async (e) => {
        e.preventDefault();

        if (!controllaCodiceFiscale(codiceFiscale)) {
            setTooltipField('codiceFiscale');
            setTooltipMessage('Codice fiscale non valido.');
            return; // Interrompe il submit
        }

        const dataPersona = {

            titolo,
            nome,
            cognome,
            codiceFiscale,
            ruolo,
            area,
            userID: user.userID,
            cciaa: user.cciaa,
            gruppoUtente:user.gruppoUtente
        }

        try {

            setAlert({ visible: false, type: '', message: '' });


            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/add/persona`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ dataPersona }),
            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }


            const json = await res.json();

            const datiRicerca = {

                dati : {
                    "id" : json.idPersona
                }
            };

            if(json.esito === 'OK'){

                navigate('/private/profiloPersona', { state: { ricerca: datiRicerca ,  nomeProfilo : json.nome , cognomeProfilo : json.cognome} });

            }else{
                navigate('/private/elencoPersone', { state: { esito: json } });
            }

        } catch (e) {
            const json = {

                esito : "KO",
                messaggio: "Errore del server."
            }
            navigate('/private/elencoPersone', { state: { esito: json } });
        }
    };

    function controllaCodiceFiscale(cfiscale) {
        if (!cfiscale || cfiscale.trim() === "") {
            return true;
        }

        const valore = cfiscale.trim().toUpperCase();
        const regex = /^[A-Z]{6}[0-9LMNP-V]{2}[A-EHLMPRST][0-9LMNP-V]{2}[A-Z][0-9LMNP-V]{3}[A-Z]$/;
        if (!regex.test(valore)) {
            return false;
        }

        const pos = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const pari = [
            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5,
            6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
            20, 21, 22, 23, 24, 25
        ];
        const disp = [
            1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13,
            15, 17, 19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14,
            16, 10, 22, 25, 24, 23
        ];

        let cont = 0;
        for (let i = 0; i < 15; i++) {
            const j = pos.indexOf(valore.charAt(i));
            cont += (i % 2 === 0) ? disp[j] : pari[j];
        }

        const checkChar = String.fromCharCode((cont % 26) + 65);
        return valore.charAt(15) === checkChar;
    }

    const handleCodiceFiscaleValidation = (value) => {
        setCodiceFiscale(value);

        if (!controllaCodiceFiscale(value)) {
            setTooltipField('codiceFiscale');
            setTooltipMessage('Codice fiscale non valido.');
        } else {
            setTooltipField(null);
            setTooltipMessage('');
        }
    };


    const handleValidationInput = ({ field, value, setField, regex, errorMessage }) => {
        const valid = regex.test(value);
        if (valid) {
            setField(value);
            setTooltipField(null);
        } else {
            setTooltipField(field);
            setTooltipMessage(errorMessage);
        }
    };

    return (

        <div className="bg-white py-5 py-lg-6">
            <Container className="py-5 py-lg-6">

                <form onSubmit={handleConferma}>

                    <Row className="justify-content-center ">
                        <Col md={9}>
                            <div style={styles.card}>
                                <h2 style={styles.formTitle}>
                                    Inserimento Persona
                                </h2>

                                {alert.visible && (
                                    <Alert color={alert.type} isOpen={alert.visible}
                                           toggle={() => setAlert({...alert, visible: false})}>
                                        {alert.message}
                                    </Alert>
                                )}

                                <Row className="mb-3">
                                    <h2 style={styles.sectionTitle}>
                                        <Icon icon="it-user" size="sm" style={styles.titleIcon}/>
                                        Dati Anagrafici
                                    </h2>
                                </Row>

                                <Row className="mb-5">
                                    <Col>
                                        <Select
                                            key={resetCount}
                                            id="titolo"
                                            label="Titolo"
                                            value={titolo}
                                            //defaultValue="*"
                                            onChange={(e) => setTitolo(e)}
                                        >
                                            <option value="null">Seleziona un titolo</option>
                                            {titoli.map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.descrizione}
                                                </option>
                                            ))}

                                        </Select>
                                    </Col>
                                </Row>

                                <Row>
                                    <Input
                                        id="nome"
                                        label="Inserisci Nome *"
                                        type="text"
                                        style={{color:'#1a1a1a', fontWeight:'700'}}
                                        wrapperClassName="col"
                                        value={nome}
                                        onChange={(e) => handleValidationInput({
                                            field: "nome",
                                            value: e.target.value,
                                            setField: setNome,
                                            regex: /^[a-zA-Z\s']*$/,
                                            errorMessage: "Sono ammessi solo caratteri alfabetici."
                                        })}
                                        required={true}
                                        maxLength={20}
                                    />
                                </Row>

                                <Row>

                                    <Input
                                        id="cognome"
                                        label="Inserisci Cognome *"
                                        type="text"
                                        wrapperClassName="col"
                                        value={cognome}
                                        style={{color:'#1a1a1a', fontWeight:'700'}}
                                        onChange={(e) => handleValidationInput({
                                            field: "cognome",
                                            value: e.target.value,
                                            setField: setCognome,
                                            regex: /^[a-zA-Z\s']*$/,
                                            errorMessage: "Sono ammessi solo caratteri alfabetici."
                                        })}
                                        required={true}
                                        maxLength={20}
                                    />

                                </Row>

                                <Row>

                                    <Input
                                        id="codiceFiscale"
                                        label="Inserisci Codice Fiscale"
                                        type="text"
                                        style={{color:'#1a1a1a', fontWeight:'700'}}
                                        wrapperClassName="col"
                                        value={codiceFiscale}
                                        onChange={(e) => handleCodiceFiscaleValidation(e.target.value)}
                                    />

                                </Row>

                                <Row className="mb-3">
                                    <h2 style={styles.sectionTitle}>
                                        <Icon icon="it-card" size="sm" style={styles.titleIcon}/>
                                        Posizione
                                    </h2>
                                </Row>

                                <Row className="mb-5">
                                    <Col>
                                        <Select
                                            key={resetCount}
                                            id="ruolo"
                                            label="Ruolo *"
                                            value={ruolo}
                                            //defaultValue="*"
                                            onChange={(e) => setRuolo(e)}
                                            required={true}

                                        >
                                            <option value="">Seleziona un ruolo</option>
                                            {ruoli.map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.titolo}
                                                </option>
                                            ))}

                                        </Select>
                                    </Col>
                                </Row>

                                <Row className="mb-5">
                                    <Col>
                                        <Select
                                            key={resetCount}
                                            id="area"
                                            label="Area di competenza *"
                                            value={area}
                                            //defaultValue="*"
                                            onChange={(e) => setArea(e)}
                                            required={true}
                                        >
                                            <option value="">Seleziona un'area</option>
                                            {aree.map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.descrAreaCompetenza}
                                                </option>
                                            ))}

                                        </Select>
                                    </Col>
                                </Row>


                                <Row className="d-flex justify-content-end">
                                    <Col sm="auto">
                                        <Button
                                            className="btn btn-outline-primary"
                                            type="submit"
                                        >
                                            Conferma
                                        </Button>
                                    </Col>
                                </Row>

                            </div>
                        </Col>

                    </Row>

                </form>

            </Container>

            <CustomTooltip
                targetId={tooltipField}
                message={tooltipMessage}
                isOpen={tooltipField !== null}
                toggle={() => setTooltipField(null)}
            />

        </div>

    );
};
export default InserimentoPersona;


